import React, {Fragment} from 'react';
import {Link, NavLink} from "react-router-dom";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {Can} from "../../../../ability-context";

import createLink from "../../../../libs/createLink";
import Authenticated from "../../../../libs/Authenticated";

import {logoutUser} from "../../../../reducers2/login";
import {markAllUserNotificationsOpen} from "../../../../creators/user.notifications";
import {fetchUnreadNotifications} from "../../../../creators/user.unreadNotification";
import {fetchUnreadRooms} from "../../../../creators/user.unreadRooms";

import Icon from "../../Icon";
import Dropdown from "../../Dropdown";
import NotificationsList from "../../notifications/components/NotificationsList";
import Avatar from "../../Avatar";
import Modal from "../../Modal";
import Upload from "../../upload/Uploads";

import ModalSubscription from "../../ModalSubscription";
import history from "../../../../libs/history";
import _ from "lodash";
import CtaCannot from "../../CtaCannot";
import FakeNotifications from "./FakeNotifications";

class NavbarConnect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toggle: true,
            toggleNotif: true,
            toggleUpload: false,
            subscription : false
        };


        this.handleToggleChildren = this.handleToggleChildren.bind(this);
        this.handleToggleNotification = this.handleToggleNotification.bind(this);
        this.handleToggleUpload = this.handleToggleUpload.bind(this);
        this.onClickModalSubscription = this.onClickModalSubscription.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.currentUserInitialized !== this.props.currentUserInitialized && nextProps.currentUserInitialized) {
            this.props.fetchUnreadNotifications();
            this.props.fetchUnreadRooms();
        }
    }

    handleToggleChildren(value) {
        this.setState({toggle: value, toggleResponsiveMenu: false});
    }

    handleToggleNotification(value) {
        this.setState({toggleNotif: value, toggleResponsiveMenu: false});
    }

    handleToggleUpload() {
        this.setState({toggleUpload: true});
        this.handleToggleChildren(false);
    }

    onClickOnLogout() {
        this.props.logoutUser();
    }

    onClickModalSubscription() {
        if (this.props.currentUser && this.props.currentUser.modalSubscribed && this.props.currentUser.modalSubscribed.modal) {
            this.setState({subscription: true});
        } else {
            history.push(this.props.currentUser.modalSubscribed.link);
        }
    };

    // shouldComponentUpdate(nextProps, nextState, nextContext) {
    //     if(nextProps.roomsInitialized !== this.props.roomsInitialized){
    //         return true;
    //     }
    //     if(this.state !== nextState){
    //         return true;
    //     }
    //     return false;
    // }

    render() {

        return (
            <Authenticated passThrough>
                {authenticated => {
                    return authenticated ? (
                        <Fragment>
                            {!this.props.showSearchBar && (
                                <div className="navbar-user-options">
                                    <Can action={"chat-webcam"} subject="all" passThrough>
                                        {can => {
                                            return can ? (
                                                <Link className={"access-messenger"} to={createLink("chatWebcam")}>
                                                    <Icon type={"chat-webcam"} className={"icon-chat"} />
                                                </Link>
                                            ) : (
                                                <CtaCannot
                                                    action={"chatWebcam"}
                                                    isModal={true}
                                                    button={
                                                        {
                                                            isBtn: false,
                                                            content: <div className={"access-messenger"}> <Icon type={"chat-webcam"} className={"icon-chat"} /></div>,
                                                            className: "btn-profile-subnav primary-reverse"
                                                        }
                                                    }
                                                />
                                            )
                                        }}
                                    </Can>
                                    <Can action={"read"} subject="Room">
                                        <Link className={"access-messenger"} to={createLink("messenger")}>
                                            <Icon type={"speech-bubbles"}/>
                                            {this.props.userUnreadRooms > 0 && <div
                                                className="notifications-count">{this.props.userUnreadRooms > 99 ? '99+' : this.props.userUnreadRooms}</div>}
                                        </Link>
                                    </Can>
                                    <Can action={"read"} subject="Notification">
                                        <Dropdown className="notification-dropdown" align="right"
                                                  handleToggleChildren={this.handleToggleNotification}
                                            // toggle={true}
                                                  toggleStatus={this.state.toggleNotif}
                                                  activableComponent={(
                                                      <div className="notifications">
                                                          <Icon type="bell"/>
                                                          {this.props.userUnreadNotifications > 0 && <div
                                                              className="notifications-count">{this.props.userUnreadNotifications > 99 ? '99+' : this.props.userUnreadNotifications}</div>}
                                                      </div>
                                                  )}>
                                            <div className="topline-notification-dropdown">
                                                <div className="title">Notifications</div>
                                                <div className="options-dropdown">
                                                    <div className="read-all"
                                                         onClick={() => this.props.markAllUserNotificationsOpen()}>Tout
                                                        marquer comme lu
                                                    </div>
                                                    -
                                                    <NavLink to={createLink("userMeSettingsOptionsNotifications")}>
                                                        <div className="settings"
                                                             onClick={() => this.setState({toggleNotif: false})}>Paramètres
                                                        </div>
                                                    </NavLink>
                                                </div>
                                            </div>
                                            <NotificationsList
                                                handleCloseDropdown={() => this.setState({toggleNotif: false})}/>
                                        </Dropdown>
                                    </Can>
                                    <Dropdown align="right" handleToggleChildren={this.handleToggleChildren}
                                              toggleStatus={this.state.toggle} activableComponent={(
                                        <Avatar
                                            avatar={_.get(this.props.currentUser, 'profile.avatar')}
                                            gender={_.get(this.props.currentUser, 'profile.gender')}/>
                                    )}>
                                        <ul className="dropdown-menu">
                                            <ul className="messenger-dropdown-style">
                                                <Can action={"upload"} subject="Media">
                                                    <li className="menu-item"
                                                        onClick={() => this.handleToggleUpload()}>
                                                        <Icon type="arrow-up"/> Envoyer une photo / vidéo
                                                    </li>
                                                </Can>
                                                {this.props.currentUser && this.props.currentUser.modalSubscribed && !_.get(this.props.currentUser, 'customer.subscribed') && (
                                                    <li className="menu-item"
                                                        onClick={() => this.onClickModalSubscription()}>
                                                        <Icon type="star-empty"/> Devenir VIP
                                                    </li>
                                                )}
                                                {this.props.currentUser && !this.props.currentUser.isCertified && this.props.currentUser.profile.gender !== 1 && (
                                                    <NavLink
                                                        to={createLink('userMeSettingsAbonnement', this.props.currentUser)}
                                                        className="menu-item"
                                                        onClick={() => this.handleToggleChildren(false)}><Icon
                                                        type="star-empty"/> Certifier mon compte</NavLink>
                                                )}

                                                <NavLink to={createLink('userMe', this.props.currentUser)}
                                                         className="menu-item"
                                                         onClick={() => this.handleToggleChildren(false)}><Icon
                                                    type="user-o"/> Mon profil</NavLink>
                                                <NavLink to={createLink('userMeAlbums', this.props.currentUser)}
                                                         className="menu-item"
                                                         onClick={() => this.handleToggleChildren(false)}><Icon
                                                    type="picture"/> Mes albums</NavLink>
                                                <NavLink to={createLink('userMeArticles', this.props.currentUser)}
                                                         className="menu-item"
                                                         onClick={() => this.handleToggleChildren(false)}><Icon
                                                    type="article"/>Mes articles</NavLink>
                                                <NavLink to={createLink('userMeFriends', this.props.currentUser)} className="menu-item"
                                                         onClick={() => this.handleToggleChildren(false)} rel={"nofollow"}><Icon
                                                    type="group"/>Mes amis</NavLink>
                                                <NavLink to={createLink('userMeSettings', this.props.currentUser)} className="menu-item"
                                                         onClick={() => this.handleToggleChildren(false)}><Icon
                                                    type="cog"/> Paramètres</NavLink>
                                                <NavLink to={createLink('commentsModeration')}
                                                         className="menu-item"
                                                         onClick={() => this.handleToggleChildren(false)}><Icon
                                                    type="report"/> Modération commentaires</NavLink>

                                            </ul>
                                            {
                                                //todo : revoir le right
                                            }
                                            <Can action={"moderation"} subject="Reporting">
                                                <ul className="messenger-dropdown-style">
                                                    <NavLink to={createLink("pcModerator")} className="menu-item"
                                                             onClick={() => this.handleToggleChildren(false)}><Icon
                                                        type="report"/> PC Modérateur</NavLink>
                                                </ul>
                                            </Can>

                                            <ul className="messenger-dropdown-style">
                                                <NavLink to={createLink("tagModerationQualifications")} className="menu-item"
                                                         onClick={() => this.handleToggleChildren(false)}><Icon
                                                    type="report"/> Médias à catégoriser</NavLink>
                                            </ul>

                                            <Can action={"verification"} subject="TagModeration">
                                                <ul className="messenger-dropdown-style">
                                                    <NavLink to={createLink("tagModerationVerifications")} className="menu-item"
                                                             onClick={() => this.handleToggleChildren(false)}><Icon
                                                        type="report"/> Médias à vérifier</NavLink>
                                                </ul>
                                            </Can>
                                            {/*<Can action={"manage"} subject="all">*/}
                                            {/*    <ul className="messenger-dropdown-style">*/}
                                            {/*        <NavLink to="/pc-moderateur" className="menu-item"*/}
                                            {/*                 onClick={() => this.handleToggleChildren(false)}><Icon*/}
                                            {/*            type="report"/> PC Modérateur</NavLink>*/}
                                            {/*        <NavLink to="/moderation" className="menu-item"*/}
                                            {/*                 onClick={() => this.handleToggleChildren(false)}><Icon*/}
                                            {/*            type="report"/> Modération du contenu</NavLink>*/}
                                            {/*        <NavLink to="/ticket" className="menu-item"*/}
                                            {/*                 onClick={() => this.handleToggleChildren(false)}><Icon*/}
                                            {/*            type="report"/> Tickets</NavLink>*/}
                                            {/*    </ul>*/}
                                            {/*</Can>*/}
                                            <ul className="messenger-dropdown-style">
                                                <li className="menu-item logout"
                                                    onClick={() => this.onClickOnLogout()}><Icon
                                                    type="sign-out"/> Me déconnecter
                                                </li>
                                            </ul>
                                        </ul>
                                    </Dropdown>
                                </div>
                            )}
                            <Modal toggle={this.state.toggleUpload}
                                   handleClose={() => this.setState({toggleUpload: false})}>
                                <Upload handleClose={() => this.setState({toggleUpload: false})}/>
                            </Modal>
                            <Modal toggle={this.state.subscription}
                                   handleClose={() => this.setState({subscription: false})}>
                                <ModalSubscription handleClose={() => this.setState({subscription: false})} />
                            </Modal>
                        </Fragment>
                    ) : !this.props.currentUser._id && !this.props.currentUserLoading && (

                        !this.props.showSearchBar && (
                            <Fragment>
                                <div className="navbar-user-options">
                                    <FakeNotifications
                                        gotoMessenger={this.gotoMessenger}
                                        toggleNotif={this.state.toggleNotif}
                                        handleToggleNotification={this.handleToggleNotification}
                                        handleCloseDropdown={()=>this.setState({toggleNotif : !this.state.toggleNotif})}
                                    />
                                </div>
                                <div className="navbar-not-logged">
                                    <Link to={createLink("signin")} rel={"nofollow"}><span>Connexion</span></Link> / <Link
                                    to={createLink("signup")} rel={"nofollow"}><span>Inscription</span></Link>
                                </div>
                            </Fragment>
                        )
                    )}}
            </Authenticated>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userUnreadNotifications: state.userUnreadNotifications.data.total || 0,
        userUnreadRooms: state.userUnreadRooms.data.total || 0,
        currentUser: state.currentUser.data,
        currentUserLoading: state.currentUser.loading,
        currentUserInitialized: state.currentUser.initialized
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    logoutUser,
    fetchUnreadRooms,
    fetchUnreadNotifications,
    markAllUserNotificationsOpen,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(NavbarConnect);